export enum Gender {
    female = 'Female',
    male = 'Male',
    notDisclosed = 'Choose Not to Disclose',
}